export const addToCartEventTwitter = (product) => {
  if (window?.twq) {
    const detail = {
      value: product.price,
      currency: `AUD`,
      contents: [
        {
          content_id: product.variantId,
          content_name: product.title,
          content_price: product.price,
        }
      ]
    };

    window?.twq('event', 'AddToCart', detail);
  }
};